var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-bg__cover fixed inset-0 bg-black transition-all duration-200 backdrop-blur-[2px] h-full w-full z-0",class:_setup.visible ? 'bg-opacity-75' : 'bg-opacity-0'},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }